import styled, { keyframes } from "styled-components";

export const ActionButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
`;

// Global shimmer animation for "AI is thinking" button
export const globalShimmer = keyframes`
  0% { 
    transform: translateX(-100%); 
  }
  100% { 
    transform: translateX(100%); 
  }
`;

export const AIThinkingButton = styled.div`
  width: 100%;
  height: 48px;
  background-color: #fff3ec;
  color: #FF6D1D;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  margin: 48px;
  border: 1.5px solid #fff3ec;
  cursor: not-allowed;
  opacity: 0.5;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 109, 29, 0.3) 50%, transparent 100%);
    animation: ${globalShimmer} 1.5s infinite;
    z-index: 1;
  }

  span {
    position: relative;
    z-index: 2;
  }
`;
